import {BaseMuWidget} from "./BaseMuWidget";
import {UiFlashMessage} from "./UiFlashMessage";
import {flashInfo, Utils} from "./Utils";
import {TicketsCL} from "./generated/TicketsCL";
import {MultiUpload, UploadContext} from "./MultiUpload";
import {fieldDefs} from "./dms/FieldDefs";

//todo: Zbavit se fancytree/jquery nebo kompletně přepsat
export class Attaches2 extends BaseMuWidget
{
	public ids: any = {};
	private attachId: number|null = null;
	private tree: any;
	beforeIndex() {
		this.container.classList.add('row');
		this.muAppendContent(`
	<div mu-id="treeConatiner" class="overflow-auto">
		<table class="table table-hover" mu-id="tree">
			<thead>
				<tr>
					<th>
						<span class="float-right" mu-id="addContainer">
							Přidat: 
							<span mu-id="addFolder" class="icon-document-dir"></span>
							<span mu-id="addFile" class="icon-document-file"></span>
						</span>
						Soubor
					</th>
					<th class="mini-hide">Vložil</th>
					<th class="mini-hide">Vloženo</th>
					<th class="mini-hide">Typ</th>
					<th class="mini-hide text-right">Velikost</th>
				</tr>
			</thead>
			<tbody mu-noindex="1">
				<tr mu-widget="AttachItem">
					<td mu-id="fileName"></td>
					<td class="mini-hide" mu-id="accountName"></td>
					<td class="mini-hide" mu-id="dtAdd"></td>
					<td class="mini-hide" mu-id="typeTitle"></td>
					<td class="mini-hide text-right" mu-id="fileSize"></td>
				</tr>
			</tbody>
		</table>
	</div>
	<div mu-id="detail" class="col-md-9">
		<h4 class="display-flex">
			<span class="flex-grow-1">Detail <span mu-id="detail_fileName"></span></span>
			<span mu-id="btClose" class="close flex-grow-0">&times;</span>
		</h4>
		<div>
			V <span mu-id="detail_dtAdd"></span> 
			vložil <strong mu-id="detail_accountName"></strong>, 
			typ <strong mu-id="detail_typeTitle"></strong>, 
			velikost <span mu-id="detail_fileSize"></span>
		</div>
		<div mu-id="detail_description"></div>
		<div>
			<span class="btn btn-primary icon-before-download" mu-id="btDownload"></span>
			<span class="btn btn-default icon-before-edit" mu-id="btEdit"></span>
			<span class="btn btn-danger icon-before-trash" mu-id="btDelete"></span>
		</div>
		<div mu-id="previewBlock" class="preview">
			<h4>Náhled</h4>
			<div mu-id="previewContainer"></div>
		</div>
	</div>
	<div mu-id="editBlock" class="col-md-9">
		<h4 class="display-flex">
			<span mu-id="editTitle" class="close flex-grow-1"></span>
			<span mu-id="btCloseEdit" class="close flex-grow-0">&times;</span>
		</h4>
		<div mu-id="editor" mu-widget=".">
			<div class="row">
				<label mu-for="file" class="col-form-label col-md-3">Soubor(y)</label>
				<div class="col-md-9">
					<div mu="files:MultiUpload"></div>
					<div mu="file:MultiUpload" mu-params='{"single":true}'></div>					
				</div>
			</div>
			<div class="row">
				<label mu-for="fileName" class="col-form-label col-md-3">Název</label>
				<div class="col-md-9">
					<input type="text" mu="fileName#fileName" class="form-control" />
				</div>
			</div>
			<div class="row">
				<label mu-for="description" class="col-form-label col-md-3">Popis</label>
				<div class="col-md-9">
					<textarea type="description" mu-bind="description" class="form-control"></textarea>
				</div>
			</div>
		</div>
		<div class="buttons"><span class="btn btn-primary icon-before-yes" mu="bSave">Uložit</span></div>
	</div>`);
	}

	protected cl: TicketsCL = new TicketsCL();

	public async afterIndex(): Promise<void> {
		this.toggleLayout('list');
		this.tree = $(this.ui.tree).fancytree({
			extensions: ["table", "dnd"],
			renderColumns: (ev: any, data: any) => this.initRow(ev, data),
			activate: (ev: any, data: any) => this.activateRow(ev, data),
			dnd: {
				autoExpandMS: 400,
				focusOnClick: true,
				preventVoidMoves: true,
				preventRecursiveMoves: true,
				dragStart: (node: any, data: any) => true,
				dragEnter: (node: any, data: any) => true,
				dragDrop: (node: any, data: any) => this.handleDragDrop(node, data),
			},
		}).fancytree("getTree");

		const urlHash = window.location.hash;
		let res: RegExpMatchArray | null = null;
		if ((res = urlHash.match(/id=([^;]+)/))) this.attachId = parseInt(res[1]);
		else if ((res = urlHash.match(/attach-([^;]+)/))) this.attachId = parseInt(res[1]);

		if (Object.keys(this.ids).length)
		{
			await this.reloadAttaches();
		}
	}

	private handleDragDrop(node: any, data: any): void {
		if (!node.folder) return false;

		this.ajax('move', {
			id: data.otherNode.key,
			parentId: node.key,
		}, (responseData: any) => {
			if (responseData.errors) {
				this.showError(responseData.errors);
			} else {
				data.otherNode.moveTo(node, responseData.hitMode);
			}
		});
	}

	private initRow(event: any, data: any): void {
		this.muActivateWidget(data.node.tr, undefined, { node: data.node });
	}

	private activateRow(event: any, data: any): void {
		this.bindDetail(data.node);
		this.toggleLayout('detail');
		this.muVisible(data.node.folder, "addContainer");
		this.muVisible(data.node.key !== 'root', ["btEdit", "btDelete"]);
		this.attachId = parseInt(data.node.key);
		window.location.hash = "id=" + data.node.key;
	}

	async addFolder_click()
	{
		const name = prompt('Zadejte název nové složky');
		if (name) {
			await this.cl.createFolder(this.ids, name, this.attachId);
			flashInfo('Složka byla vytvořena');
			this.reloadAttaches();
		}
	}

	async reloadAttaches(): Promise<void>
	{
		return new Promise(async(resolve, reject) => {
			const data = await this.cl.getBcmAttachesFor(this.ids);
			this.tree.reload(data).done(() => {
				let n = this.tree.getNodeByKey(this.attachId?.toString());
				if (n)
				{
					n.setActive(true);
					while(n)
					{
						n.setExpanded(true);
						n = n.parent;
					}
				}
				const rootNode = this.tree.getNodeByKey('root');
				if (rootNode) {
					rootNode.setExpanded(true);
				}

				resolve();
			});
		});
	}

	addFile_click()
	{
		this.loadEditor(null, this.attachId);
	}

	async bindDetail(node) {
		for(const k of ['typeTitle', 'fileSize', 'accountName', 'dtAdd', 'description'])
			this.ui['detail_' + k].innerText = node.data[k];
		this.ui.detail_fileName.innerText = node.title;
		this.muVisible(node.data.previewAvailable, "previewBlock");
		this.ui.previewContainer.innerHTML = "Načítám náhled";
		if (node.data.previewAvailable)
		{
			this.ui.previewContainer.innerHTML = await this.cl.getAttachDetail(parseInt(node.key), null);
		}
	}

	protected id: number|null = null;
	protected parentId: number|null = null;

	async loadEditor(id: number|null, parentId: number|null)
	{
		this.id = id;
		this.parentId = parentId;

		this.toggleLayout('edit');
		let data: any, label = "";

		if (id) {
			data = await this.cl.getAttachData(parseInt(id), null);
			label = "Upravit " + data.fileName;
		} else {
			data = { fileName: "", description: "", id: null, parentId };
			label = "Nová příloha";
		}

		const n = !id;
		const f = data.contentType === '.folder';

		this.muNamedWidget.editor.muVisible(!n && !f, 'file');
		this.muNamedWidget.editor.muVisible(n, 'files');
		this.muNamedWidget.editor.muVisible(!n || f, 'fileName');

		this.ui.editTitle.innerText = label;
		this.muNamedWidget.editor.muBindData(data);
	}

	async bSave_click()
	{
		const data = this.muNamedWidget.editor.muFetchData();
		if (!this.id) data.parentId = this.parentId;
		const saveAttach = async (data: any) => {
			await this.cl.saveAttach(
				this.id,
				this.ids,
				data
			);
		};
		const prepareAttach = async (context: UploadContext, data: any) => {
			context.url = await this.cl.newTempFile();
			data.file = {
				tmpFile: context.url,
				fileName: context.file.name,
				contentType: context.file.type,
				fileSize: context.file.size,
			}
		};

		if (this.id) {
			await (this.muNamedWidget.editor.muNamedWidget.file as unknown as MultiUpload).sendToBackend(
				async (context, send) => {
					await prepareAttach(context, data);
					await send();
					flashInfo("Příloha byla aktualizována")
				}
			);
			await saveAttach(data);
		} else {
			await (this.muNamedWidget.editor.muNamedWidget.files as unknown as MultiUpload).sendToBackend(
				async (context, send) => {
					const newData = { ...data };
					await prepareAttach(context, newData);
					await send();
					await saveAttach(newData);
					flashInfo("Příloha byla uložena")
				}
			);
		}
		await this.reloadAttaches();
	}

	toggleLayout(state)
	{
		this.ui.tree.classList.toggle('mini', state != 'list');
		this.ui.treeConatiner.classList.toggle('col-md-3', state != 'list');
		this.muVisible(state == 'detail', "detail");
		this.muVisible(state == 'edit', "editBlock");
	}

	btClose_click(event, data) {
		this.toggleLayout('list');
	}

	btCloseEdit_click(event, data) {
		this.toggleLayout('detail');
	}

	btDownload_click()
	{
		window.open("/attach-download/" + this.attachId + '/0', '_blank');
	}

	btEdit_click()
	{
		this.loadEditor(this.attachId);
	}

	btReplace_click() { }

	btArchive_click() { }

	btDelete_click()
	{
		if (confirm('Opravdu smazat?'))
		{
			this.ajax(
				'delete', {id: this.attachId}, function(data) {
					if (data.errors) this.showError(data.errors);
					else
					{
						flashInfo('Smazáno');
						this.attachId = parseInt(this.tree.getNodeByKey('root').parent.key);
						this.reloadAttaches();
					}
				}
			)
		}
	}

	showError(error)
	{
		if (Array.isArray(error))
		{
			var hUl = document.createElement("ul");
			res.errors.forEach(msg => {
				var hLi = document.createElement("li");
				hLi.innerText = msg;
				hUl.appendChild(hLi);
			});
			flashInfo(hUl, "danger");
		}
		else
		{
			flashInfo(error, "danger");
		}
	}

	// ajax: (...p: any) => any = Utils.ajax;
	// getUrl: (...p: any) => any = Utils.getUrl;
	// ajaxForm: (...p: any) => any = Utils.ajaxForm;

	public hasAnyAttach(): boolean
	{
		return this.tree.rootNode.children.length > 0;
	}
}

